<template>
  <div class="invoice-history-list">
    <div class="invoice-history-list__title">
      <div class="breadcrumb">
        <span class="title">我的订阅</span>
        >
        <span class="gray">开票记录</span>
      </div>
      <span class="main-text back" @click="back">返回</span>
    </div>
    <div class="invoice-history-list__content">
      <List :totalCount="totalCount" @flipPage="flipPage" :currentPage="currentPageNo" :pageSize="10">
        <template v-slot:listContent>
          <div class="invoice-history-list-wrapper">
            <el-table ref="multipleTable" :header-cell-style="setHeaderCellStyle" :data="tableData" border style="width: 100%">
              <el-table-column align="center" v-for="(col, index) in columns" :key="index" :label="col.label" :prop="col.prop" :width="col.width" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
          </div>
        </template>
      </List>
    </div>
  </div>
</template>

<script>
import List from '@components/list/listFrame'
import moment from 'moment'
import invoice from '@api/invoice'
export default {
  name: 'InvoiceHistoryList',
  components: { List },
  data() {
    return {
      totalCount: 0,
      currentPageNo: 1,
      tableData: [],
      amount: 0,
      columns: [
        {
          prop: 'applyNumber',
          label: '申请单号'
        },
        {
          prop: 'invoiceAccount',
          label: '开票方'
        },
        {
          prop: 'invoiceAmount',
          label: '金额'
        },
        {
          prop: 'createTime',
          label: '开票日期'
        },
        {
          prop: 'invoiceStatus',
          label: '开票状态'
        },
        {
          prop: 'contactWay',
          label: '联系方式'
        }
      ],
      isAll: false
    }
  },
  created() {
    this.getData()
  },
  methods: {
    back() {
      this.$parent.showInvoiceHistory = false
    },
    setHeaderCellStyle() {
      return { 'background-color': '#F7F7F7 ', color: '#333' }
    },
    flipPage(pageNo) {
      this.currentPageNo = pageNo
      this.getData()
    },
    getData() {
      let params = {
        pageNo: this.currentPageNo,
        pageSize: 10
      }
      invoice.findInvoiceByPage(params).then((res) => {
        let { status, data } = res.data
        if (status == 0) {
          this.tableData = data.page.result
          this.tableData.forEach((_) => {
            _.createTime = moment(_.createTime).format('YY-MM-DD HH:mm:ss')
            if (_.invoiceStatus == 0) _.invoiceStatus = '已通知出版单位'
            if (_.invoiceStatus == 1) _.invoiceStatus = '已开票'
          })
          this.totalCount = data.page.totalCount
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.invoice-history-list {
  font-size: 14px;
  padding-right: 30px;
  &__title {
    .breadcrumb {
      display: inline-block;
      margin-bottom: 10px;
      .title {
        font-size: 17px;
        font-weight: bold;
      }
      .gray {
        color: #515151;
      }
    }
    span.back {
      float: right;
    }
  }

  /deep/.common-list-wrapper .page-component {
    margin-top: -10px;
  }
}
</style>
